import React from "react";
import PropTypes from "prop-types";
import {Swiper, SwiperSlide} from 'swiper/react';
import {getIntlLocale} from "../../lib/getIntlLocale";
import {i18nFormat} from "../../lib/i18nFormat";

export function Order(props) {
  const orderDate = new Date(props.order.date);
  const intlLocale = getIntlLocale();

  const formattedDate = orderDate.toLocaleDateString(intlLocale, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
  const formattedTime = orderDate.toLocaleTimeString(intlLocale, {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="account-order">
      <div className="account-order__component">
        <div className="account-order__content">
          <div className="account-order__info">
            <h3 className="account-order__name">
              {i18nFormat("orders.order.name", { orderId: props.order.id })}
            </h3>
            <div className="account-order__details">
              <span className="account-order__date">
                {i18nFormat("orders.order.date", { date: formattedDate, time: formattedTime })}
              </span>
            </div>
          </div>
          <Swiper
            className="account-order__swiper"
            spaceBetween={12}
            slidesPerView={"auto"}
            grabCursor={true}
          >
            {props.order.items.map((item) =>
              Array.from({length: item.quantity}).map((_, index) => (
                <SwiperSlide key={`${item.title}-${index}`}>
                  <div className="account-order__item" title={item.title}>
                    <img
                      className="account-order__item-image"
                      src={item.image}
                      alt={item.title}
                      draggable={false}
                    />
                  </div>
                </SwiperSlide>
              ))
            )}
          </Swiper>
          <div className="account-order__footer">
            <a className="account-order__link" href={props.order.url}
               target="_blank" rel="noopener noreferrer">
              <span>{i18nFormat("orders.order.link")}</span>
              <span className="glyph-core-square-arrow-up-right"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

Order.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
  }).isRequired,
}
